import { create } from 'zustand';
import api from '../utils/api';

const useSettingsStore = create((set) => ({
  portalName: 'Primosa Exams',
  logoUrl: '',
  loginBgUrl: '',
  primaryColor: '#4f46e5',
  secondaryColor: '#0f172a',
  defaultLanguage: 'en',
  scoreCardTemplate: 'classic',
  scoreCardShowQR: true,
  scoreCardShowGradeScale: false,
  loaded: false,

  fetchSettings: async () => {
    try {
      const res = await api.get('/settings');
      const {
        portalName, logoUrl, loginBgUrl, primaryColor, secondaryColor, defaultLanguage, scoreCardTemplate,
        scoreCardShowQR, scoreCardShowGradeScale,
      } = res.data.data;
      set({
        portalName: portalName || 'Primosa Exams',
        logoUrl: logoUrl || '',
        loginBgUrl: loginBgUrl || '',
        primaryColor: primaryColor || '#4f46e5',
        secondaryColor: secondaryColor || '#0f172a',
        defaultLanguage: defaultLanguage || 'en',
        scoreCardTemplate: scoreCardTemplate || 'classic',
        scoreCardShowQR: scoreCardShowQR !== false,
        scoreCardShowGradeScale: !!scoreCardShowGradeScale,
        loaded: true
      });
    } catch {
      set({ loaded: true });
    }
  },

  setSettings: (portalName, logoUrl, loginBgUrl, primaryColor, secondaryColor) => set((state) => ({
    portalName,
    logoUrl,
    loginBgUrl: loginBgUrl !== undefined ? loginBgUrl : state.loginBgUrl,
    primaryColor: primaryColor !== undefined ? primaryColor : state.primaryColor,
    secondaryColor: secondaryColor !== undefined ? secondaryColor : state.secondaryColor,
  })),

  // Separate from setSettings (positional, tied to the branding form) since
  // these two fields are saved independently from their own Settings cards.
  patchSettings: (partial) => set(partial),
}));

export default useSettingsStore;
